import { ColDef } from "ag-grid-community";
import { remPixelSize } from "../../Layout/LayoutConsts";
import { ValueFormatterParams } from "ag-grid-community";
import format from "format-number";

export const defaultColDef: ColDef = {
  sortable: true,
  filter: true,
};

export const columnDefs: ColDef[] = [
  {
    headerName: "Pozycja",
    field: "lineNumber",
    minWidth: 6 * remPixelSize,
  },
  {
    headerName: "Kod pozycji",
    field: "lineCode",
    minWidth: 8 * remPixelSize,
  },
  {
    headerName: "Numer katalogowy",
    field: "catalogNumber",
    minWidth: 8 * remPixelSize,
  },
  {
    headerName: "Nazwa towaru",
    field: "productName",
    minWidth: 25 * remPixelSize,
  },
  {
    cellClass: ["text-end"],
    headerClass: "-app-centered-header",
    headerName: "Ilość",
    field: "amount",
    minWidth: 6 * remPixelSize,
    valueFormatter: fourFractionDigitsColumnFormatter,
  },
];

const fourFractionDigitsFormat = format({
  integerSeparator: "\xA0",
  round: 4,
  decimal: ",",
  padRight: 4,
});

export function fourFractionDigitsColumnFormatter(
  params: ValueFormatterParams
): string {
  return numberValueToFourDecimalDigitsString(params.value);
}

export function numberValueToFourDecimalDigitsString(value: any): string {
  if (typeof value === "number") {
    return fourFractionDigitsFormat(value);
  } else {
    return "";
  }
}
